import {
  Deal,
  getDealSettings,
  OrderValues,
  PackageConfig,
  RemoteConfig,
} from '@ca/common/types'

import { isPackageAvailable } from '@order/isPackageAvailable'
import { validateItem } from '@order/utils/validateItem'

export const getUpgrades = ({
  deal,
  upgradeDeals,
  packages,
  basePackage,
  values,
}: {
  deal: Deal | undefined
  upgradeDeals: Deal[] | undefined
  packages: Record<string, PackageConfig>
  basePackage?: PackageConfig | null
  values: OrderValues
}) => {
  if (!deal) {
    return []
  }
  const settings = getDealSettings(deal)
  const ownUpgrades = deal.upgrades
    .map((upgrade) => ({
      config: packages[upgrade],
      deal,
    }))
    .filter((p) =>
      isPackageAvailable(p.config, basePackage, values, settings.upgradeTypes)
    )

  if (!upgradeDeals || !upgradeDeals.length) {
    return ownUpgrades
  }

  const upgradePackages = upgradeDeals
    .flatMap((deal) => {
      return deal.packages.map((upgrade) => ({
        config: packages[upgrade],
        deal,
      }))
    })
    .filter((p) => isPackageAvailable(p.config, basePackage, values, []))

  return [...ownUpgrades, ...upgradePackages]
}

export const getPackageVariant = (
  item: PackageConfig | null | undefined,
  config: RemoteConfig,
  { values, refraction }: OrderValues
) => {
  if (!refraction) {
    return null
  }
  const validated = item?.variants.filter((variant) =>
    validateItem(variant, values, config.conditions, refraction).result
  )
  if (!validated?.length) {
    return null
  }
  return validated[0]
}
